import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_green/src/app/error.tsx");
